import React, { useEffect } from 'react';
import { SalesHero } from '../components/SalesHero';
import { SalesContent } from '../components/SalesContent';
import { SalesOffer } from '../components/SalesOffer';
import { Footer } from '../components/Footer';
import { initMetaPixel } from '../utils/metaPixel';
export function SalesPage() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <main className="min-h-screen bg-cream-100 text-ink-900 font-sans selection:bg-slate-teal/20 selection:text-ink-900" data-id="element-198">
      <SalesHero data-id="element-199" />
      <SalesContent data-id="element-200" />
      <SalesOffer data-id="element-201" />
      <Footer data-id="element-202" />
    </main>;
}